export enum BOOKING_STATUS {
    PROCESSING = 'Processing',
    PENDING_PAYMENT = 'Pending payment',
    CONFIRMED = 'Confirmed',
    ORDER_CHANGED = 'Order changed',
    PAYMENT_FAILED = 'Payment failed',
    CANCELED = 'Canceled',
    PENDING_REFUND = 'Pending refund',
    REFUND_FAILED = 'Refund failed',
    REFUNDED = 'Refunded',
}

export const BOOKING_STATUS_CONFIG: Record<keyof typeof BOOKING_STATUS, { textColor: string; bgColor: string; style: string; }> = {
    PROCESSING: { textColor: '#1570EF', bgColor: '#EFF8FF', style: 'text-[#1570EF] bg-[#EFF8FF]' },
    PENDING_PAYMENT: { textColor: '#DC6803', bgColor: '#FFFAEB', style: 'text-[#DC6803] bg-[#FFFAEB]' },
    CONFIRMED: { textColor: '#099250', bgColor: '#EDFCF2', style: 'text-[#099250] bg-[#EDFCF2]' },
    ORDER_CHANGED: { textColor: '#099250', bgColor: '#EDFCF2', style: 'text-[#099250] bg-[#EDFCF2]' },
    PAYMENT_FAILED: { textColor: '#475467', bgColor: '#F2F4F7', style: 'text-[#475467] bg-[#F2F4F7]' },
    CANCELED: { textColor: '#475467', bgColor: '#F2F4F7', style: 'text-[#475467] bg-[#F2F4F7]' },
    PENDING_REFUND: { textColor: '#475467', bgColor: '#F2F4F7', style: 'text-[#475467] bg-[#F2F4F7]' },
    REFUND_FAILED: { textColor: '#475467', bgColor: '#F2F4F7', style: 'text-[#475467] bg-[#F2F4F7]' },
    REFUNDED: { textColor: '#099250', bgColor: '#EDFCF2', style: 'text-[#099250] bg-[#EDFCF2]' }
};